import { render, staticRenderFns } from "./PendingReviewList.vue?vue&type=template&id=559df066&scoped=true&"
import script from "./PendingReviewList.vue?vue&type=script&lang=js&"
export * from "./PendingReviewList.vue?vue&type=script&lang=js&"
import style0 from "./PendingReviewList.vue?vue&type=style&index=0&id=559df066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559df066",
  null
  
)

export default component.exports